import React from 'react';

export default function BetaBanner() {
  const handleFeedbackClick = () => {
    window.open('https://docs.google.com/forms/d/e/1FAIpQLSe4adnW2-ShP5Yla7zrAyX66kaFmDFmCNdfmv-KZUkIkf5LxQ/viewform?usp=publish-editor', '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="bg-orange-500 text-white py-3 px-4 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-7xl flex items-center justify-between">
        <div className="flex items-center space-x-3">
          <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-semibold bg-orange-600">
            BETA
          </span>
          <p className="text-sm sm:text-base">
            We're currently in beta. Help us improve by sharing your feedback!
          </p>
        </div>
        <button
          onClick={handleFeedbackClick}
          className="ml-4 inline-flex items-center px-4 py-2 rounded-md bg-white text-orange-600 font-medium text-sm hover:bg-orange-50 transition-colors whitespace-nowrap"
        >
          Send Feedback
        </button>
      </div>
    </div>
  );
}
